import React from 'react';
import { TargetIcon } from 'lucide-react';
export function ResultsSection() {
  return <section className="w-full bg-bg-primary py-16 md:py-24 px-4" data-id="element-429">
      <div className="max-w-5xl mx-auto" data-id="element-430">
        <div className="text-center mb-12 md:mb-16" data-id="element-431">
          <div className="inline-flex items-center justify-center w-12 h-12 md:w-16 md:h-16 bg-cta/10 rounded-full mb-4 md:mb-6" data-id="element-432">
            <TargetIcon className="w-6 h-6 md:w-8 md:h-8 text-cta" data-id="element-433" />
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4 md:mb-6" data-id="element-434">
            Resultados esperados
          </h2>
          <p className="text-base md:text-xl text-text-secondary leading-relaxed max-w-3xl mx-auto" data-id="element-435">
            Al completar el sistema EMPRENDE USA EXPRESS, habrás construido una
            infraestructura empresarial completa y sólida.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6" data-id="element-436">
          <div className="bg-bg-card p-6 md:p-8 rounded-lg border border-cta/20" data-id="element-437">
            <div className="w-10 h-10 md:w-12 md:h-12 bg-cta/10 rounded-lg flex items-center justify-center mb-3 md:mb-4" data-id="element-438">
              <span className="text-cta font-bold text-lg md:text-xl" data-id="element-439">✓</span>
            </div>
            <h3 className="text-lg md:text-xl font-semibold mb-2 md:mb-3" data-id="element-440">
              Empresa correctamente registrada
            </h3>
            <p className="text-sm md:text-base text-text-secondary leading-relaxed" data-id="element-441">
              Tu empresa estará registrada formalmente ante el estado con su
              estructura legal completa, Operating Agreement, y base legal
              establecida.
            </p>
          </div>

          <div className="bg-bg-card p-6 md:p-8 rounded-lg border border-cta/20" data-id="element-442">
            <div className="w-10 h-10 md:w-12 md:h-12 bg-cta/10 rounded-lg flex items-center justify-center mb-3 md:mb-4" data-id="element-443">
              <span className="text-cta font-bold text-lg md:text-xl" data-id="element-444">✓</span>
            </div>
            <h3 className="text-lg md:text-xl font-semibold mb-2 md:mb-3" data-id="element-445">
              Identidad fiscal configurada
            </h3>
            <p className="text-sm md:text-base text-text-secondary leading-relaxed" data-id="element-446">
              Tendrás tu EIN obtenido correctamente y la identidad fiscal de tu
              empresa configurada ante el IRS según las mejores prácticas.
            </p>
          </div>

          <div className="bg-bg-card p-6 md:p-8 rounded-lg border border-cta/20" data-id="element-447">
            <div className="w-10 h-10 md:w-12 md:h-12 bg-cta/10 rounded-lg flex items-center justify-center mb-3 md:mb-4" data-id="element-448">
              <span className="text-cta font-bold text-lg md:text-xl" data-id="element-449">✓</span>
            </div>
            <h3 className="text-lg md:text-xl font-semibold mb-2 md:mb-3" data-id="element-450">
              Infraestructura financiera operativa
            </h3>
            <p className="text-sm md:text-base text-text-secondary leading-relaxed" data-id="element-451">
              Tu cuenta bancaria empresarial estará abierta correctamente, con
              finanzas separadas de las personales y lista para operar.
            </p>
          </div>

          <div className="bg-bg-card p-6 md:p-8 rounded-lg border border-cta/20" data-id="element-452">
            <div className="w-10 h-10 md:w-12 md:h-12 bg-cta/10 rounded-lg flex items-center justify-center mb-3 md:mb-4" data-id="element-453">
              <span className="text-cta font-bold text-lg md:text-xl" data-id="element-454">✓</span>
            </div>
            <h3 className="text-lg md:text-xl font-semibold mb-2 md:mb-3" data-id="element-455">
              Sistema de cumplimiento activo
            </h3>
            <p className="text-sm md:text-base text-text-secondary leading-relaxed" data-id="element-456">
              Tendrás tu Calendario del Dueño implementado para mantener tu
              empresa en cumplimiento continuo con todas sus obligaciones.
            </p>
          </div>

          <div className="bg-bg-card p-6 md:p-8 rounded-lg border border-cta/20" data-id="element-457">
            <div className="w-10 h-10 md:w-12 md:h-12 bg-cta/10 rounded-lg flex items-center justify-center mb-3 md:mb-4" data-id="element-458">
              <span className="text-cta font-bold text-lg md:text-xl" data-id="element-459">✓</span>
            </div>
            <h3 className="text-lg md:text-xl font-semibold mb-2 md:mb-3" data-id="element-460">
              Comprensión completa del sistema
            </h3>
            <p className="text-sm md:text-base text-text-secondary leading-relaxed" data-id="element-461">
              Entenderás cómo funciona el sistema empresarial en EE.UU. y podrás
              tomar decisiones informadas sobre tu empresa.
            </p>
          </div>

          <div className="bg-bg-card p-6 md:p-8 rounded-lg border border-cta/20" data-id="element-462">
            <div className="w-10 h-10 md:w-12 md:h-12 bg-cta/10 rounded-lg flex items-center justify-center mb-3 md:mb-4" data-id="element-463">
              <span className="text-cta font-bold text-lg md:text-xl" data-id="element-464">✓</span>
            </div>
            <h3 className="text-lg md:text-xl font-semibold mb-2 md:mb-3" data-id="element-465">
              Control total sobre tu empresa
            </h3>
            <p className="text-sm md:text-base text-text-secondary leading-relaxed" data-id="element-466">
              Tendrás el conocimiento y la estructura necesarios para operar tu
              empresa con confianza y control completo.
            </p>
          </div>
        </div>

        <div className="mt-8 md:mt-12 bg-gradient-to-r from-cta/10 to-transparent border-l-4 border-cta p-6 md:p-8 rounded-lg" data-id="element-467">
          <p className="text-base md:text-lg leading-relaxed" data-id="element-468">
            <span className="font-semibold text-cta" data-id="element-469">Importante:</span> Estos
            son resultados estructurales y educativos. EMPRENDE USA EXPRESS te
            enseña a construir y dominar la infraestructura de tu empresa. No
            prometemos resultados financieros ni ingresos específicos.
          </p>
        </div>
      </div>
    </section>;
}